// hooks/useApiFeedback.ts
import { useState } from 'react';
import { FeedbackDto, Validation } from '../common/models/requests/FeedbackDto';

export type ApiResponse = {
  payload?: {
    data?:any;
    errors?: any;
    validation?: Validation;
  };
  type?: string;
  error?: any;
};

export const useApiFeedback = () => {
  const [feedback, setFeedback] = useState<FeedbackDto>({
    validation: { code: 0, messages: [] },
    severity: undefined,
    open: false,
    error: '',
    isSuccess: false,
  });

  const handleApiResponse = (response: ApiResponse, showSuccess = false) => {
    // Handle error cases first
    if (response.error || response.payload?.errors) {
      const errorMessage = response.error?.message || 
                          response.payload?.errors?.message || 
                          'Something went wrong while processing your request.';
      
      setFeedback({
        open: true,
        severity: 'error',
        isSuccess: false,
        error: errorMessage,
        payload:response.payload?.data,
        validation: {
          code: response.payload?.validation?.code || 400,
          messages: [errorMessage],
        },
      });
      return;
    }

    // Handle successful responses with validation
    if (response.payload?.validation) {
      const { code, messages } = response.payload.validation;
      const isSuccess = code === 200 || code === 201;
      
      setFeedback({
        open: isSuccess ? showSuccess : true,
        severity: isSuccess ? 'success' : 'error',
        isSuccess,
        error: '',
        validation: {
          code,
          messages: Array.isArray(messages) ? messages : [messages],
        },
      });
      return;
    }

    // Default case for unrecognized responses
    setFeedback({
      open: true,
      severity: 'error',
      isSuccess: false,
      error: 'Unexpected response format',
      validation: {
        code: 500,
        messages: ['Unexpected response format from server'],
      },
    });
  };

  const resetFeedback = () => {
    setFeedback({
      validation: { code: 0, messages: [] },
      severity: undefined,
      open: false,
      error: '',
      isSuccess: false,
    });
  };

  return { feedback, handleApiResponse, resetFeedback };
};